import { Link } from "react-router-dom";
import { DA_XUAT_BAN, tenPhu } from "../data/glossary.js";
import { GIAI_THICH } from "../data/toolGiaiThich.js";
import DoanVan from "./DoanVan.jsx";

/**
 * Phần giải thích sau khung kết quả: Dùng khi nào, Cách tính, Thuật ngữ.
 * Render sẵn lúc build (không phụ thuộc ngày giờ hay dữ liệu người dùng),
 * nên Google đọc được và mỗi trang công cụ nối sang Từ điển.
 * Thuật ngữ lấy tự động từ Từ điển theo relatedTools; công cụ chưa có nội dung
 * trong toolGiaiThich.js thì chỉ hiện khối thuật ngữ.
 */
const HIEN_TRUOC = 6;

const Icon = ({ d }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{d}</svg>
);
const ICON = {
  khiNao: <><circle cx="12" cy="12" r="9" /><path d="M15.5 8.5l-2 5-5 2 2-5z" /></>,
  congThuc: <><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M8 7h8M8 11h2M12 11h2M16 11h0M8 15h2M12 15h2M8 18h2M12 18h4" /></>,
  thuatNgu: <><path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" /><path d="M4 19V5M8 7h7" /></>,
};

/** Dòng phụ chỉ hiện tên gốc tiếng Anh; bản dịch tiếng Việt (vd. của pre-money) chỉ nằm ở trang từ điển. */
const tenGoc = (t) => {
  const p = tenPhu(t);
  return p && !/[À-ỹđĐ]/.test(p) && p.toLowerCase() !== t.term.toLowerCase() ? p : "";
};

function TheThuatNgu({ t }) {
  return (
    <li className="gt-tn">
      <h3>
        <Link to={"/thuat-ngu/" + t.slug}>{t.term}</Link>
        {tenGoc(t) && <span>{tenGoc(t)}</span>}
      </h3>
      <p>{t.shortDef}</p>
    </li>
  );
}

export default function ToolGiaiThich({ tool }) {
  const nd = GIAI_THICH[tool.slug];
  const thuatNgu = DA_XUAT_BAN.filter((t) => t.relatedTools?.includes(tool.toolId))
    .sort((a, b) => (a.priority || 3) - (b.priority || 3));
  if (!nd && !thuatNgu.length) return null;
  const truoc = thuatNgu.slice(0, HIEN_TRUOC);
  const sau = thuatNgu.slice(HIEN_TRUOC);

  return (
    <section className={"gt" + (nd ? "" : " chi-thuat-ngu")} aria-label="Giải thích công cụ">
      {nd && (
        <div className="gt-trai">
          {nd.khiNao?.length > 0 && (
            <div className="gt-the">
              <h2><Icon d={ICON.khiNao} />Dùng công cụ này khi nào</h2>
              <ul className="gt-ds">
                {nd.khiNao.map((x) => <li key={x}><DoanVan chu={x} /></li>)}
              </ul>
            </div>
          )}
          {(nd.congThuc?.length > 0 || nd.giaiThich) && (
            <div className="gt-the">
              <h2><Icon d={ICON.congThuc} />Cách tính</h2>
              {nd.congThuc?.length > 0 && (
                <div className="gt-cong-thuc">
                  {nd.congThuc.map((x) => <p key={x}>{x}</p>)}
                </div>
              )}
              {nd.giaiThich && <p className="gt-doan"><DoanVan chu={nd.giaiThich} /></p>}
            </div>
          )}
        </div>
      )}
      {thuatNgu.length > 0 && (
        <div className="gt-the gt-phai">
          <h2><Icon d={ICON.thuatNgu} />Thuật ngữ trong công cụ</h2>
          <ul className="gt-tn-ds">
            {truoc.map((t) => <TheThuatNgu key={t.slug} t={t} />)}
          </ul>
          {sau.length > 0 && (
            <details className="gt-them">
              <summary>Xem thêm {sau.length} thuật ngữ</summary>
              <ul className="gt-tn-ds">
                {sau.map((t) => <TheThuatNgu key={t.slug} t={t} />)}
              </ul>
            </details>
          )}
          <p className="gt-tu-dien"><Link to="/thuat-ngu">Mở Từ điển đầy đủ →</Link></p>
        </div>
      )}
    </section>
  );
}
